export default {
	'--color1v1': '#e4b70e',
	'--color1v2': '#c58e09',
	'--color1v1Border': '#c58e09',
	'--color1v2Border': '#9d660b',
	'--color1Text': 'black',

	'--color2v1': '#5a726a',
	'--color2v2': '#495e57',
	'--color2v1Border': '#748d84',
	'--color2v2Border': '#5a726a',
	'--color2Text': 'white',

	'--inputColor': '#6e4215',
	'--inputText': 'white',

	'--disabledButton': '#ced1d3',
	'--disabledButtonBorder': '#a9aeb1',
	'--disabledButtonText': 'black',

	'--footerbg': 'black',
	'--footerText': 'white',

	'--headerColor': '#3a3c3f',
	'--headerText': 'white',
	'--navButtonBorder': 'white',

	'--backgroundColor': '#242528',
	'--backgroundColorText': 'white'
} as React.CSSProperties;
